import { useTranslation } from 'react-i18next';

import { VISUAL_REFRESH } from 'common/utils';

import { CopyButton, DsCopyField } from './components';
import { StyledTextField } from './CopyTextField.styled';

import type { TextInputPosition } from '@natter-co/design-system';

type Props = {
  value: string;
  /** Accessible name. With the visual refresh on, a field without one stays on MUI. */
  label?: string;
  /** Names the legacy field without switching it to the floating-label DS field. */
  hiddenLabel?: string;
  /** Hide the visible label when nearby text already names the field. */
  labelHidden?: boolean;
  /** Refresh-only. `FieldGroup` normally supplies it, to round only the outer corners of a stack. */
  position?: TextInputPosition;
};

export const CopyTextField = ({ value, label, hiddenLabel, labelHidden, position }: Props) => {
  const { t } = useTranslation('common');
  return VISUAL_REFRESH && label ? (
    <DsCopyField value={value} label={label} labelHidden={labelHidden} position={position} />
  ) : (
    <StyledTextField
      value={value}
      fullWidth
      InputProps={{ readOnly: true }}
      inputProps={{ 'aria-label': label ?? hiddenLabel ?? t('clipboard.content') }}
      suffix=<CopyButton value={value} label={label ?? hiddenLabel} />
    />
  );
};
